import Vue from 'vue'

export default {
  wpSearchReplace ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.post('engine/wordpress/' + data.id + '/search-replace', data))
  },
  wpCheckLocation ({ commit }, data) {
    return Vue.api.post('engine/wordpress/check-location', data)
  },
  wpImportData ({ commit }, data) {
    return Vue.api.post('engine/wordpress/' + data.id + '/import-data', data)
  }
}
